import { apiRequest } from "@portal/lib/ky/utils";
import { CustomFieldDataResponse } from "@portal/types/entities/custom-field";

export async function getCustomFields() {
  const data = await apiRequest<unknown, CustomFieldDataResponse[]>({
    method: "GET",
    url: "v1/custom-fields/filter-fields",
  });
  return await data.json();
}

export async function getCustomFieldsColumns() {
  const data = await apiRequest<unknown, CustomFieldDataResponse[]>({
    method: "GET",
    url: "v1/custom-fields/invoice-custom-fields",
  });
  return await data.json();
}
